<template>
  <fragment>
    <!-- scrollable -->
    <b-modal id="modal-manage-page" title="Manage Page" hide-footer no-close-on-esc no-close-on-backdrop>
      <template #modal-header="{ close }">
        <div class="w-100 px-5">
          <div class="d-flex justify-content-between pb-10">
            <div class="modal-title d-flex align-items-center">
              <TitleModal
                :label="`${$t('engine.managePage.pageManage.lblTitle', languageEngine)} - ${languageUse && languageUse.toUpperCase()}`" />
              <i :class="`flag-icon flag-icon-${languages &&
                languages[languageUse] &&
                languages[languageUse].flagIcon
                } fs-16 ml-8 -mt-3`"></i>
            </div>
            <div class="d-flex align-items-center">
              <div @click="close(), (text = ''), (expan_id = '')" type="button" aria-label="Close"
                id="close-modal-manage-header-menu" class="ml-5 close-modal">
                <i class="fal fa-times"></i>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <b-button class="fs-sa-14" variant="blue" @click="addPage">
              <i class="fas fa-plus"></i>
              {{ $t("engine.managePage.pageManage.btnAdd", languageEngine) }}
            </b-button>
            <div class="flex-grow-1 pl-10">
              <div style="position: relative">
                <span class="text-muted" style="position: absolute; left: 10px; top: 7px">
                  <i class="far fa-search"></i>
                </span>
                <b-form-input style="padding-left: 35px" v-model="text" :placeholder="`${$t(
                  'engine.managePage.pageManage.lblSearch',
                  languageEngine
                )}`"></b-form-input>
                <span v-show="text !== ''" class="text-muted" style="
                    position: absolute;
                    right: 10px;
                    top: 7px;
                    cursor: pointer;
                  " @click="text = ''">
                  <i class="fas fa-times-circle"></i>
                </span>
              </div>
            </div>
            <div class="ml-10 position-relative cl">
              <b-dropdown ref="dropdownFilters" variant="light" id="dropdownFilters" toggle-class="text-decoration-none"
                menu-class="mw-205">
                <template #button-content class="text-muted">
                  <span class="position-relative" :class="[filter ? 'text-primary' : 'text-muted']">
                    <i class="fas fa-filter"></i>
                    <CheckIcon v-show="filter" class="position-absolute text-primary filter-page">
                      <i class="fas fa-check-circle"></i>
                    </CheckIcon>
                  </span>
                  <span class="pl-gd-1 fs-sa-14 text-left">
                    {{
                      $t(
                        "engine.managePage.pageManage.btnFilter",
                        languageEngine
                      )
                    }}
                  </span>
                </template>
                <div>
                  <div class="pl-15 pr-10 pr-2 d-flex">
                    <div class="fs-dbb-20">
                      {{
                        $t(
                          "engine.managePage.pageManage.lblFilter",
                          languageEngine
                        )
                      }}
                    </div>
                    <span class="ml-auto cursor-pointer" @click="closeDropdown('state')">
                      <i class="far fa-times"></i>
                    </span>
                  </div>
                  <div class="pl-20 pr-2 mt-2">
                    <b-form-checkbox-group v-model="tmpFilterMember" :options="options" class="mb-3" value-field="item"
                      text-field="name" disabled-field="notEnabled"></b-form-checkbox-group>
                  </div>
                  <hr class="mb-0" />

                  <div class="px-2 w-100 d-flex">
                    <div class="w-50 pt-2 text-center text-danger cursor-pointer" @click="closeDropdown()">
                      <span class="fs-sa-14">
                        {{
                          $t(
                            "engine.managePage.pageManage.btnFilterClear",
                            languageEngine
                          )
                        }}
                      </span>
                    </div>
                    <div class="w-50 pt-2 text-center text-primary cursor-pointer" @click="closeDropdown(false)">
                      <span class="fs-sa-14">
                        {{
                          $t(
                            "engine.managePage.pageManage.btnFilterApply",
                            languageEngine
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </b-dropdown>
            </div>
          </div>
        </div>
      </template>

      <div class="wrapper-boby">
        <div class="wrapper-boby-inner">
          <div v-if="text !== '' || filter" class="pb-15 fs-dbb-20">
            <div style="margin-left: -5px">
              {{
                $t(
                  "engine.managePage.pageManage.lblSearchResult",
                  languageEngine
                )
              }}
              ({{ countSearch }})
            </div>
            <hr class="mt-0 mb-2" style="margin-left: -5px" />
          </div>

          <div class="text-center text-muted" v-if="countSearch === 0">
            {{ $t("engine.managePage.pageManage.msgNotFound", languageEngine) }}
          </div>

          <!-- item -->
          <div v-for="key in Object.keys(getListByType)" :key="`${key}`">
            <GroupTitle class="fs-sa-14" v-if="key !== 'home' && getListByType[key][0].data > 0">
              {{ getTitle(key) }}
            </GroupTitle>

            <template v-for="page in getListByType[key]">
              <PageItem :ref="`page-item-${page.id}`" :id="`page-item-${page.id}`" :key="`page_${key}_index_${page.id}`"
                v-if="page.show" class="d-flex justify-content-between page-item" :class="{
                  active: expan_id === `tools${page.id}`,
                  bactive: expan_id,
                  lastItem: page.id === isLast(key, page),}">
                <!-- :id="`tools${page.id}`" -->

                <div style="width: 100%;">
                  <div class="row" :class="{'fix-height-custom-page': page.properties.groupType === 'custom'}">

                    <!-- !icon -->
                    <div class="col-auto pr-0 iconMangePage" 
                    :class="{
                      'd-flex align-items-center' : page.properties.groupType === 'custom',
                      'pt-3' : page.properties.groupType !== 'custom'
                      }">
                      <div  v-if="mainPage === page.id">
                        <!-- ! icon home page -->
                        <homeIcon></homeIcon>
                      </div>

                      <div v-else >
                        <!-- ! icon custom page -->
                        <div v-if="page.properties.groupType === 'custom'">
                          <customPageIcon></customPageIcon>
                        </div>
                        <!-- !icon system page -->
                        <div v-else-if="page.properties.groupType === 'system'">
                          <blogIcon v-if="page.properties.type === 'content_list' || page.properties.type === 'content_item'"></blogIcon>
                          <photoAlbumIcon v-else-if="page.properties.type === 'album_list' || page.properties.type === 'album_item'"></photoAlbumIcon>
                          <formIcon v-else-if="page.properties.type === 'form_item' || page.properties.type === 'quotation_form_item'"></formIcon>
                          <eventCalendarIcon v-else-if="page.properties.type === 'event_calendar'"></eventCalendarIcon>
                          <contactIcon v-else-if="page.properties.type === 'contact'"></contactIcon>
                          <faqIcon v-else-if="page.properties.type === 'faq'"></faqIcon>
                          <informPaymentIcon v-else-if="page.properties.type === 'inform_payment' || page.properties.type === 'online_payment'"></informPaymentIcon>
                          <productIcon v-else-if="page.properties.type === 'product_list' || page.properties.type === 'product_item' || page.properties.type === 'product_brand'"></productIcon>
                          <orderTrackingIcon v-else-if="page.properties.type === 'order_tracking'"></orderTrackingIcon>
                          <termsAndConditionIcon v-else-if="page.properties.type === 'terms_condition' || page.properties.type === 'policy'"></termsAndConditionIcon>
                          <giftcardIcon v-else-if="page.properties.type === 'giftcard_list' || page.properties.type === 'giftcard_item'"></giftcardIcon>
                          <customPageIcon v-else></customPageIcon>
                        </div>
                      </div>
                    </div>

                    <!--! name and type -->
                    <div class="col-9" 
                    :class="{'d-flex align-items-center' : page.properties.groupType === 'custom'}" 
                    style="padding-left: 12px;">
                      <div class="text-left">

                        <!-- !page name -->
                        <div class="fs-sa-14 text-truncate text-left"
                          :class="{ homeactive: mainPage === page.id, 'text-truncate': true, }"
                          style="max-width: 300px;">
                          {{ page.properties.name }}
                        </div>
                      </div>

                      <div class="page-type d-block text-left" v-if="page.properties.groupType !== 'custom'">
                        {{ getPageType(page) }}
                      </div>
                    </div>

                     <!-- !permission and tools -->
                    <div class="col-2 text-right px-0 position-static"
                    :class="{
                      'd-flex align-items-center justify-content-end' : page.properties.groupType === 'custom',
                      'd-flex justify-content-end' : page.properties.groupType === 'system'
                      }">
                      <!-- !icon lock member -->
                      <span class="mr-5" v-show="page.properties.permission.type !== 'public'">
                        <span v-b-tooltip.hover title="Member Only"
                          class="iconPermission"
                          v-show="page.properties.permission.type === 'member'">
                          <i class="far fa-user icon-style"></i>
                        </span>
                        <span v-b-tooltip.hover title="Password holder"
                          class="iconPermission"
                          v-show="page.properties.permission.type === 'password'">
                          <i class="far fa-lock-alt icon-style"></i>
                        </span>
                      </span>
                      <!-- !icon eyes -->
                      <span class="mr-5 iconPermission" v-b-tooltip.hover title="Hide Page"
                        v-if="page.properties.isEnable === false">
                        <i class="far fa-eye-slash icon-style"></i>
                      </span>
                      <!-- ! tools -->
                      <span class="tool cursor-pointer p-0 ml-3" style="height: 20px;">
                        <div class="cursor-pointer tools-more-menu d-inline-block" :id="`tools${page.id}`" @click="fixExpan(page)"
                          :class="{
                            active: expan_id === `tools${page.id}`,
                          }">
                          <i class="fas fa-ellipsis-h text-muted mb-3 icon-more-menu"
                            style="pointer-events: none; font-size: 14px"></i>
                        </div>
                        <b-popover :target="`tools${page.id}`" triggers="click" placement="right" ref="popover"
                          :container="`tools${page.id}`" boundary="viewport">
                          <div>
                            <div class="cursor-pointer option" @click="editPage(page.id)">
                              <span>
                                <i class="far fa-edit mr-8"></i>
                              </span>
                              {{
                                $t(
                              "engine.managePage.pageManage.btnEdit",
                              languageEngine
                              )
                              }}
                            </div>

                            <div v-show="page.properties.groupType != 'system'" class="cursor-pointer option"
                              @click="copyPage(page)">
                              <span>
                                <i class="far fa-clone mr-8"></i>
                              </span>
                              {{
                                $t(
                              "engine.managePage.pageManage.btnDuplicate",
                              languageEngine
                              )
                              }}
                            </div>
                            <div class="cursor-pointer option" @click="hompage(page.id)" v-show="mainPage !== page.id && page.properties.isEnable && page.properties.groupType != 'system'
                              ">
                              <span>
                                <i class="far fa-home mr-8"></i>
                              </span>
                              {{
                                $t(
                              "engine.managePage.pageManage.btnSetHome",
                              languageEngine
                              )
                              }}
                            </div>

                            <div class="cursor-pointer option" @click="status(page.id)" v-if="mainPage !== page.id">
                              <span v-show="page.properties.isEnable">
                                <i class="far fa-eye mr-8"></i>
                              </span>
                              <span v-show="!page.properties.isEnable">
                                <i class="far fa-eye-slash mr-8"></i>
                              </span>
                              {{
                                !page.properties.isEnable
                                  ? $t(
                                    "engine.managePage.pageManage.btnShow",
                                    languageEngine
                              )
                              : $t(
                              "engine.managePage.pageManage.btnHide",
                              languageEngine
                              )
                              }}
                            </div>

                            <div class="cursor-pointer option" @click="preDelete(page.id)" v-if="mainPage !== page.id">
                              <span>
                                <i class="far fa-trash-alt mr-8"></i>
                              </span>
                              {{
                                $t(
                              "engine.managePage.pageManage.btnDelete",
                              languageEngine
                              )
                              }}
                            </div>
                          </div>
                        </b-popover>
                      </span>
                    </div>

                  </div>
                </div>
              </PageItem>
            </template>
          </div>
        </div>
      </div>
    </b-modal>

    <SelectTemplatePage @setData="setData" />
    <AddPage :action="action" :id="item_id" :templateData="templateData" @clear="clear" @scrollToPage="scrollToPage" />
    <ConfirmSetHome :namePage="namePage" @confirmed="setHomePage(item_id)" @clear="clear" />
    <ConfirmHidePage :namePage="namePage" @confirmed="updateStatus(item_id)" @clear="clear" />
    <ConfirmDelete :id="item_id" :namePage="namePage" :action="action" @confirmed="deletePage(item_id)"
      @clear="clear" />
    <SwitchPage :lang="langDuplicate" :flag="flagDuplicate" :namePage="nameDuplicate" :metaDataID="metaDataIDDuplicate"
      @clear="clear" />
    <DuplicatePage :id="item_id" :action="action" @clear="clear" @setCopyName="setCopyName" @setCopyLang="setCopyLang"
      @setMetaDataIDDuplicate="setMetaDataIDDuplicate" @scrollToPage="scrollToPage" />
    <SelectTemplateWebsite />

    <ModalConfirmUpgrade :modalID="'modal-confirm-upgrade-duplicate'"
      :title="$t('engine.common.dialogAlertLimit.lblTitlePageLimit', languageEngine)"
      :message="$t('engine.common.dialogAlertLimit.lblDescPageLimit', languageEngine)" />
  </fragment>
</template>

<script>
import { GroupTitle, PageItem, CheckIcon } from "./ManagePage.styled";
import AddPage from "@components_system/Design/Modal/AddPage/AddPage";
import ConfirmSetHome from "./dialogConformSetHomePage.vue";
import ConfirmHidePage from "./dialogConformHidePage.vue";
import ConfirmDelete from "./dialogConformDelete.vue";
import DuplicatePage from "./dialogDuplicatePage.vue";
import SwitchPage from "./dialogRoute.vue";
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";
import pageService from "@services/pageService.js";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import SelectTemplatePage from "@components_system/Design/Modal/SelectTemplatePage/SelectTemplatePage";
import SelectTemplateWebsite from "@components_system/Design/Modal/SelectTemplateWebsite/SelectTemplateWebsite";
import ModalConfirmUpgrade from "@components_system/Design/Modal/ModalConfirmUpgrade/ModalConfirmUpgrade.vue";

// icon
import customPageIcon from '@components_system/Shared/Images/mangePage/icon-custom-page.vue'
import blogIcon from '@components_system/Shared/Images/mangePage/icon-blog.vue'
import eventCalendarIcon from '@components_system/Shared/Images/mangePage/icon-event-calendar.vue'
import homeIcon from '@components_system/Shared/Images/mangePage/icon-home.vue'
import photoAlbumIcon from '@components_system/Shared/Images/mangePage/icon-photo-album.vue'
import contactIcon from '@components_system/Shared/Images/mangePage/icon-contact.vue'
import faqIcon from '@components_system/Shared/Images/mangePage/icon-faq.vue'
import informPaymentIcon from '@components_system/Shared/Images/mangePage/icon-inform-payment.vue'
import productIcon from '@components_system/Shared/Images/mangePage/icon-product.vue'
import formIcon from '@components_system/Shared/Images/mangePage/icon-form.vue'
import orderTrackingIcon from '@components_system/Shared/Images/mangePage/icon-order-tracking.vue'
import termsAndConditionIcon from '@components_system/Shared/Images/mangePage/icon-terms-and-condition.vue'
import giftcardIcon from '@components_system/Shared/Images/mangePage/icon-giftcard.vue'


export default {
  components: {
    GroupTitle,
    PageItem,
    CheckIcon,
    AddPage,
    ConfirmSetHome,
    ConfirmDelete,
    DuplicatePage,
    SwitchPage,
    ConfirmHidePage,
    TitleModal,
    SelectTemplatePage,
    SelectTemplateWebsite,
    ModalConfirmUpgrade,

    // icon
    customPageIcon,
    blogIcon,
    eventCalendarIcon,
    homeIcon,
    photoAlbumIcon,
    contactIcon,
    faqIcon,
    informPaymentIcon,
    productIcon,
    formIcon,
    orderTrackingIcon,
    termsAndConditionIcon,
    giftcardIcon,
  },
  data() {
    return {
      text: "",
      // action: "add",
      action: "",
      item_id: "",
      namePage: "",
      nameDuplicate: "",
      langDuplicate: "",
      flagDuplicate: "",
      metaDataIDDuplicate: "",
      filterMember: [],
      tmpFilterMember: [],
      filter: false,
      expan_id: "",
      loading: false,
      templateData: {},
      templateDataTemp: {},
    };
  },
  computed: {
    ...mapGetters({
      languages: "design/site/languages",
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      siteComponents: "design/metadata/siteComponents",
      sitePageID: "design/metadata/sitePageID",
      design: "design/site/design",
      permissions: "design/permissionWebsite/permissions",
    }),
    pageLimitNumber() {
      return this.permissions.PageNumber;
    },
    pageNumber() {
      const temp = JSON.parse(JSON.stringify(this.siteComponents));
      return Object.keys(temp).filter(item => temp[item].type == 'PAGE' && temp[item].properties.type == 'section').length || 0;
    },
    mainPage() {
      return this.siteComponents.MAIN_PAGE.properties.pageID;
    },
    getListByType() {
      this.filter;
      this.action;
      var object_list = {
        home: [{ data: 0 }],
        custom: [{ data: 0 }],
        system: [{ data: 0 }],
      };

      if (this.siteComponents) {
        Object.entries(JSON.parse(JSON.stringify(this.siteComponents))).forEach(
          ([key, item]) => {
            key;
            let type = "plus";
            if (item.type === "PAGE") {
              item.show = true;
              if (this.text !== "" && this.filterMember.length === 0) {
                if (
                  item.properties.name &&
                  item.properties.name
                    .toLowerCase()
                    .indexOf(this.text.toLowerCase()) > -1
                ) {
                  item.show = true;
                  type = "plus";
                } else {
                  item.show = undefined;
                  type = "minus";
                }
              } else if (this.text === "" && this.filterMember.length !== 0) {
                if (
                  this.filterMember.indexOf(item.properties.permission.type) !=
                  -1
                ) {
                  item.show = true;
                  type = "plus";
                } else {
                  item.show = undefined;
                  type = "minus";
                }
              } else if (this.text !== "" && this.filterMember.length !== 0) {
                if (
                  this.filterMember.indexOf(item.properties.permission.type) !=
                  -1 &&
                  item.properties.name &&
                  item.properties.name
                    .toLowerCase()
                    .indexOf(this.text.toLowerCase()) > -1
                ) {
                  item.show = true;
                  type = "plus";
                } else {
                  item.show = false;
                  type = "minus";
                }
              }
              switch (item.properties.groupType) {
                case "system":
                  type === "plus" ? (object_list.system[0].data += 1) : "";
                  object_list.system.push(item);
                  break;
                case "home":
                  type === "plus" ? (object_list.home[0].data += 1) : "";
                  object_list.home.push(item);
                  break;
                case "custom":
                  type === "plus" ? (object_list.custom[0].data += 1) : "";
                  object_list.custom.push(item);
                  break;
              }
            }
          }
        );
      }
      return object_list;
    },
    options() {
      return [
        {
          item: "public",
          name: this.$t(
            "engine.managePage.pageManage.btnFilterPublic",
            this.languageEngine
          ),
        },
        {
          item: "password",
          name: this.$t(
            "engine.managePage.pageManage.btnFilterPassword",
            this.languageEngine
          ),
        },
        {
          item: "member",
          name: this.$t(
            "engine.managePage.pageManage.btnFilterMember",
            this.languageEngine
          ),
        },
      ];
    },
    countSearch() {
      return (
        this.getListByType.home[0].data +
        this.getListByType.custom[0].data +
        this.getListByType.system[0].data
      );
    },
    pageDefaultData() {
      return {
        custom: {
          about_us: {
            title: this.$t(
              "engine.commonPage.pageType.template.aboutus",
              this.languageEngine
            ),
            type: "about_us",
            group_type: "custom",
          },
          service: {
            title: this.$t(
              "engine.commonPage.pageType.template.service",
              this.languageEngine
            ),
            type: "service",
            group_type: "custom",
          },
        }
        ,
        system: {
          content_list: {
            title: this.$t(
              "engine.commonPage.pageType.contentList",
              this.languageEngine
            ),
            type: "content_list",
            group_type: "system",
          }
          ,
          content_item: {
            title: this.$t(
              "engine.commonPage.pageType.contentItem",
              this.languageEngine
            ),
            type: "content_item",
            group_type: "system",
          }
          ,
          album_list: {
            title: this.$t(
              "engine.commonPage.pageType.albumList",
              this.languageEngine
            ),
            type: "album_list",
            group_type: "system",
          }
          ,
          album_item: {
            title: this.$t(
              "engine.commonPage.pageType.albumItem",
              this.languageEngine
            ),
            type: "album_item",
            group_type: "system",
          }
          ,
          form_item: {
            title: this.$t(
              "engine.commonPage.pageType.formItem",
              this.languageEngine
            ),
            type: "form_item",
            group_type: "system",
          }
          ,
          faq: {
            title: this.$t(
              "engine.commonPage.pageType.faqList",
              this.languageEngine
            ),
            type: "faq",
            group_type: "system",
          }
          ,
          contact: {
            title: this.$t(
              "engine.commonPage.pageType.contact",
              this.languageEngine
            ),
            type: "contact",
            group_type: "system",
          }
          ,
          event_calendar: {
            title: this.$t(
              "engine.commonPage.pageType.eventCalendar",
              this.languageEngine
            ),
            type: "event_calendar",
            group_type: "system",
            permission: "IsCalendar",
          }
          ,
          product_list: {
            title: this.$t(
              "engine.commonPage.pageType.productList",
              this.languageEngine
            ),
            type: "product_list",
            group_type: "system",
          }
          ,
          product_item: {
            title: this.$t(
              "engine.commonPage.pageType.productItem",
              this.languageEngine
            ),
            type: "product_item",
            group_type: "system",
          }
          ,
          product_brand: {
            title: this.$t(
              "engine.commonPage.pageType.productBrandList",
              this.languageEngine
            ),
            type: "product_brand",
            group_type: "system",
          }
          ,
          giftcard_list: {
            title: this.$t(
              "engine.commonPage.pageType.giftcard_list",
              this.languageEngine
            ),
            type: "giftcard_list",
            group_type: "system",
          }
          ,
          inform_payment: {
            title: this.$t(
              "engine.commonPage.pageType.informPayment",
              this.languageEngine
            ),
            type: "inform_payment",
            group_type: "system",
          }
          ,
          online_payment: {
            title: this.$t(
              "engine.commonPage.pageType.onlinePayment",
              this.languageEngine
            ),
            type: "online_payment",
            group_type: "system",
          }
          ,
          order_tracking: {
            title: this.$t(
              "engine.commonPage.pageType.orderTracking",
              this.languageEngine
            ),
            type: "order_tracking",
            group_type: "system",
          }
          ,
          terms_condition: {
            title: this.$t(
              "engine.commonPage.pageType.terms",
              this.languageEngine
            ),
            type: "terms_condition",
            group_type: "system",
          }
          ,
          policy: {
            title: this.$t(
              "engine.commonPage.pageType.policy",
              this.languageEngine
            ),
            type: "policy",
            group_type: "system",
          }
          ,
          quotation_form_item: {
            title: this.$t(
              "engine.commonPage.pageType.quotationFormItem",
              this.languageEngine
            ),
            type: "quotation_form_item",
            group_type: "system",
          }
        },
      };
    },
  },
  props: {
    value: {
      type: Number,
    },
  },
  mounted() {
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId == "dropdownFilters") {
        if (!this.filter) {
          this.tmpFilterMember = [];
          this.filterMember = [];
        } else {
          this.tmpFilterMember = this.filterMember;
        }
      }
    });

    this.$root.$on("bv::modal::shown", () => {
      const _vm = this;
      $(".modal").on("click", function (bvEvent) {
        if (
          _vm.expan_id &&
          bvEvent.target.className != "cursor-pointer tools-more-menu active"
        ) {
          _vm.$root.$emit("bv::hide::popover", _vm.expan_id);
          _vm.expan_id = "";
          _vm.enable();
        }
      });
    });
  },
  created() { },

  methods: {
    capitalize,
    setData($e) {
      this.templateData = { ...$e };
      this.action = 'add';
    },
    async scrollToPage(value) {
      if (value) {
        this.loading = true;
        const timer = setInterval(() => {
          let $elem = document.getElementById("page-item-" + value);
          if ($elem) {
            this.loading = false;
            clearInterval(timer);
            setTimeout(() => {
              $elem.scrollIntoView({
                behavior: "smooth",
                block: "end",
              });
              // $elem.classList.add("page-item-last");
            }, 100); // delay for dom render
          }
        }, 1);
      }
    },

    preventScroll(e) {
      e.preventDefault();
    },

    disable() {
      document
        .querySelector(".modal-body")
        .addEventListener("wheel", this.preventScroll);
    },

    enable() {
      document
        .querySelector(".modal-body")
        .removeEventListener("wheel", this.preventScroll, false);
    },

    fixExpan(page) {
      if (`tools${page.id}` === this.expan_id) {
        this.expan_id = "";
        this.enable();
      } else {
        this.expan_id = String(`tools${page.id}`);
        this.disable();
      }
    },

    getTitle(type) {
      var label = "";
      switch (type) {
        case "custom":
          label = this.$t(
            "engine.managePage.pageManage.lblCustom",
            this.languageEngine
          );
          break;
        case "system":
          label = this.$t(
            "engine.managePage.pageManage.lblSystem",
            this.languageEngine
          );
          break;
        default:
          label = this.$t(
            "engine.managePage.pageManage.lblHome",
            this.languageEngine
          );
          break;
      }
      return label;
    },
    addPage() {
      this.action = "add";
      this.$bvModal.hide("modal-manage-page");
      // this.$bvModal.show("modal-add-page");
      this.$bvModal.show("modal-select-template-page");
    },
    editPage(id) {
      this.action = "edit";
      this.item_id = id;
      this.expan_id = "";
      this.$bvModal.hide("modal-manage-page");
      this.$bvModal.show("modal-add-page");
    },
    status(id) {
      if (this.siteComponents[id].properties.isEnable) {
        this.action = "homepage";
        this.item_id = id;
        this.expan_id = "";
        this.namePage = this.siteComponents[id].properties.name;
        this.$bvModal.show("modal-confirm-hide-page");
      } else {
        this.updateStatus(id);
      }
    },
    updateStatus(id) {
      this.siteComponents[id].properties.isEnable =
        !this.siteComponents[id].properties.isEnable;
      this.$store.dispatch("design/snapshot/genSnapshot");
      this.$toast.success({
        title: this.$t(
          "engine.common.alert.success.title",
          this.languageEngine
        ),
        message: this.$t(
          this.siteComponents[id].properties.isEnable ? "engine.managePage.showpage.msgShowSuccess" : "engine.managePage.hidepage.msgHideSuccess",
          this.languageEngine
        ),
      });
      this.action = "";
      this.item_id = "";
      this.expan_id = "";
    },
    hompage(id) {
      this.action = "homepage";
      this.item_id = id;
      this.expan_id = "";
      this.namePage = this.siteComponents[id].properties.name;
      this.$bvModal.show("modal-confirm-set-home-page");
    },
    setHomePage(id) {
      this.siteComponents.MAIN_PAGE.properties.pageID = id;
      this.$store.dispatch("design/snapshot/genSnapshot");
      this.$toast.success({
        title: this.$t(
          "engine.common.alert.success.title",
          this.languageEngine
        ),
        message: this.$t(
          "engine.managePage.setHome.msgSetHomeSuccess",
          this.languageEngine
        ),
      });
      this.action = "";
      this.item_id = "";
      this.expan_id = "";
    },
    preDelete(id) {
      this.action = "delete";
      this.item_id = id;
      this.expan_id = "";
      this.namePage = this.siteComponents[id].properties.name;
      this.$bvModal.show("modal-confirm-delete");
    },
    async deletePage(id) {
      this.action = "delete";

      await this.$store.dispatch('design/snapshot/synceSnapshot', {});

      const lang = this.languageUse;
      const temp = [
        {
          op: "remove",
          path: `/languages/${lang}/SITE/assets/components/${id}`,
        },
        {
          op: "remove",
          path: `/languages/${lang}/pages/${id}`,
        },
      ];

      // Process
      pageService
        .managesPage({ data: { actions: temp, transactionID: localStorage.getItem('lastTransactionID') } })
        .then(async (response) => {
          localStorage.setItem('lastTransactionID', response.transactionID)

          const metaDataID =
            id === this.sitePageID
              ? this.siteComponents[this.mainPage].properties.metaDataID
              : this.siteComponents[this.sitePageID].properties.metaDataID;

          // Load Page
          await this.$store.dispatch("designIframe/page/getPage", {
            metaDataID: metaDataID,
          });

          this.$toast.success({
            title: this.$t(
              "engine.common.alert.success.title",
              this.languageEngine
            ),
            message: this.$t(
              "engine.managePage.delete.msgDeleteSuccess",
              this.languageEngine
            ),
          });
          this.clear();
        })
        .catch(() => {
          this.$toast.error(
            <div>
              <span class="title">
                {this.$t(
                  "engine.common.alert.error.title",
                  this.languageEngine
                )}
              </span>
              {this.$t(
                "engine.managePage.delete.msgDeleteFail",
                this.languageEngine
              )}
            </div>,
            { icon: "fas fa-times-circle" }
          );
          this.clear();
        });
    },
    deletePage_old(id) {
      this.action = "delete";
      const lang = this.languageUse;
      delete this.siteComponents[id];
      this.$store.dispatch("design/snapshot/genSnapshot");
      const temp = [
        {},
        {
          op: "remove",
          path: `/languages/${lang}/pages/${id}`,
        },
      ];
      pageService
        .managesPage({ data: { actions: temp, transactionID: localStorage.getItem('lastTransactionID') } })
        .then(async (response) => {
          localStorage.setItem('lastTransactionID', response.transactionID)
          this.$toast.success({
            title: this.$t(
              "engine.common.alert.success.title",
              this.languageEngine
            ),
            message: this.$t(
              "engine.managePage.delete.msgDeleteSuccess",
              this.languageEngine
            ),
          });
          setTimeout(() => {
            this.$store.dispatch("designIframe/page/getSiteMetadata", {
              lang: "",
            });
          }, 2500);
          if (id === this.sitePageID) {
            const metaData =
              this.siteComponents[this.mainPage].properties.metaDataID;
            this.$store.dispatch("designIframe/page/getPage", {
              metaDataID: metaData,
            });
          }
          this.action = "";
        })
        .catch(() => { });
    },
    copyPage(page) {
      if (this.canDuplicate(page)) {
        this.$bvModal.show('modal-confirm-upgrade-duplicate');
      } else {
        this.item_id = page.id;
        this.expan_id = "";
        this.action = "duplicate";
        this.$bvModal.show("modal-duplicate-page");
      }
    },
    closeDropdown(clear = true) {
      if (clear === "state") {
        if (this.filter == false) {
          this.filterMember = [];
          this.tmpFilterMember = [];
        }
        this.$refs.dropdownFilters.hide(true);
        return;
      }
      if (clear) {
        this.filterMember = [];
        this.tmpFilterMember = [];
        this.filter = false;
      }
      if (!clear) {
        this.filterMember = [...this.tmpFilterMember];
        if (this.filterMember.length > 0) {
          this.filter = true;
        } else {
          this.filter = false;
        }
      }
      this.$refs.dropdownFilters.hide(true);
    },
    setCopyName(value) {
      this.nameDuplicate = value;
    },
    setCopyLang(value) {
      this.langDuplicate = value;
      this.flagDuplicate = this.languages[value].flagIcon;
    },
    setMetaDataIDDuplicate(value) {
      this.metaDataIDDuplicate = value;
    },
    clear() {
      this.action = "";
      this.item_id = "";
      this.expan_id = "";
      this.text = "";
    },
    isLast(key) {
      let lastIndex = "";
      let lastName = this.getListByType[key].slice(-1);

      lastIndex = lastName[0].id;
      return lastIndex;
    },
    canDuplicate(page) {
      let limit = false
      if (this.pageNumber >= this.pageLimitNumber && page.properties.type == 'section') {
        limit = true;
      }
      return limit;
    },
    getPageType(prop = {}) {
      if (prop) {
        switch (prop.properties.groupType) {
          case 'system':
            return prop.properties.type === 'product_list' ? this.pageDefaultData[prop.properties.groupType][prop.properties.type].title + " - " + this.getProductTypeFromUrl(prop.properties.url) : this.pageDefaultData[prop.properties.groupType][prop.properties.type].title;
          case 'custom':
            return this.mainPage === prop.id ? this.$t( "engine.managePage.pageManage.lblHome", this.languageEngine ) : this.$t('engine.managePage.pageManage.lblCustom', this.languageEngine);
          default:
            return this.$t('engine.managePage.pageManage.lblCustom', this.languageEngine);
        }
      }
    },
    getProductTypeFromUrl(url = "") {
      let arrUrl = url.split("");
      if (arrUrl.length) {
        arrUrl = arrUrl.splice(0, 6)
        switch (arrUrl.join('')) {
          case 'catego':
              return this.$t('engine.commonProduct.dataType.category', this.languageEngine);
          case 'produc':
              return this.$t('engine.commonProduct.dataType.brand', this.languageEngine);
          case 'bestse':
              return this.$t('engine.commonProduct.dataType.bestSeller', this.languageEngine);
          case 'promot':
              return this.$t('engine.commonProduct.dataType.promotion', this.languageEngine);
          case 'flashs':
              return this.$t('engine.commonProduct.dataType.flashSale', this.languageEngine);
          default:
            return '';
        }
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="scss">
.page-type {
  color: #A4A9AF;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Sarabun;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
  /* 133.333% */
}

.tool span svg {
  cursor: pointer;
}
.mw-205 {
  min-width: 205px !important;
}
#dropdownFilters ul {
  border: 0px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}
#modal-manage-page {
  .modal-dialog-scrollable .modal-content {
    overflow: unset !important;
  }
  .modal-body {
    padding: 0rem;
    height: auto;
    max-height: calc(80vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    border-bottom-right-radius: calc(0.3rem - 1px);
  }
  .modal-content {
    width: 500px;
    margin: auto;
  }
  .wrapper-boby-inner {
    padding: 10px 20px;
  }
  .text-danger {
    &:hover {
      color: #a03e3b !important;
    }
  }
  .text-primary {
    &:hover {
      color: #009cc1 !important;
    }
  }
  .lastItem {
    padding: 5px 20px 10px 20px;
  }
  /* Customize website's scrollbar like Mac OS
  Not supports in Firefox and IE */

  /* total width */
  ::-webkit-scrollbar {
    background-color: #fff;
    width: 16px;
  }

  /* background of the scrollbar except button or resizer */
  ::-webkit-scrollbar-track {
    background-color: #fff;
  }

  /* scrollbar itself */
  ::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 4px solid #fff;
  }

  /* set button(top and bottom of the scrollbar) */
  ::-webkit-scrollbar-button {
    display: none;
  }
}

#modal-manage-page___BV_modal_body_ {
  position: static;
}

.iconMangePage {
  div{
    display: flex;
    height: 16px;
    width: 16px;
    align-items: center;
    justify-content: center;
  }
}
.fix-height-custom-page{
  height: 24px;
}

.iconPermission{
  display: flex;
  height: 20px;
  width: 20px;
  justify-content: center;
  align-items: center;
}
</style>